import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import { useAppSelector } from '../../store/reducers';
import InputLabel from '../Form/InputLabel/InputLabel';
import UploadUserPhotoModal from '../Modals/UploadUserPhotoModal/UploadUserPhotoModal';
import { pickUserAvatar } from '../PhotoSelect/PhotoSelect';
import { PROFILE_AVATARS } from '../PhotoSelect/PhotoSelectData';
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './UploadPhoto.module.scss';
const UploadPhoto = ({ className }) => {
    const { t } = useTranslation();
    const ref = useRef(null);
    const userInfo = useAppSelector((state) => state.app.userInfo);
    const [photoSelect, showPhotoSelect] = useState(false);
    const [showDefault, setShowDefault] = useState(true);
    const [avatarPath, setAvatarPath] = useState('');
    useEffect(() => {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo) {
            const collection = PROFILE_AVATARS[0];
            const asset = pickUserAvatar(collection.contents, userInfo.photo);
            if ('string' === typeof asset) {
                setShowDefault(false);
                setAvatarPath(asset);
            }
            else {
                setShowDefault(true);
            }
        }
        else {
            setShowDefault(true);
        }
    }, [userInfo, userInfo === null || userInfo === void 0 ? void 0 : userInfo.photo]);
    return (_jsxs("div", Object.assign({ className: cn(className, styles.element, 'flex-1') }, { children: [_jsx(InputLabel, { children: t('profile_picture') }), _jsx("div", Object.assign({ onClick: () => showPhotoSelect(true), className: cn(styles.box, 'd-flex align-items-center') }, { children: _jsx("div", Object.assign({ className: cn('position-relative d-flex align-items-center') }, { children: _jsxs("div", Object.assign({ className: cn('d-flex align-items-center') }, { children: [_jsx("div", Object.assign({ className: cn(styles.inputLabel) }, { children: showDefault ? _jsx(Logo, {}) : _jsx("img", { src: avatarPath, alt: "" }) })), _jsxs("div", Object.assign({ className: 'd-flex flex-column' }, { children: [_jsx(Paragraph, { className: styles.uploadPhoto, title: t('select_avatar') }), _jsx(Paragraph, { className: styles.recognize, title: t('photos_help_other_users_recognize') })] }))] })) })) })), photoSelect && (_jsx(UploadUserPhotoModal, { closeModal: () => showPhotoSelect(false), forwardRef: ref, isOpen: photoSelect }))] })));
};
export default UploadPhoto;
